import axios from "axios";
import authHeader from "./auth-header";
import { config } from "../config";
import AuthService from "./auth.service";

class EntitiesService {
  getAll() {
    return axios
      .get(`${config.apiUrl}entities`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return [];
      });
  }

  index(params) {
    return axios
      .get(`${config.apiUrl}entities`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response?.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return null;
      });
  }

  create(bodyParms) {
    return axios
      .post(`${config["apiUrl"]}entities`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 201) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  update(id, bodyParms) {
    return axios
      .put(`${config["apiUrl"]}entities/${id}`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  query(params) {
    return axios
      .get(`${config["apiUrl"]}entities/query`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

}

export default new EntitiesService();
